import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  acceptedCount: number;
  overriddenCount: number;
  rejectedCount: number;
}

export const AgentPublishConfirmationAlertContent: React.FC<Props> = ({
  acceptedCount,
  overriddenCount,
  rejectedCount,
}) => {
  const [styles, theme] = useStyles();

  const accepted =
    acceptedCount > 0 ? (
      <Typography
        color={theme.sk.color.text.success}
        variant="paragraph-md-600"
      >
        {i18n.t(
          acceptedCount === 1
            ? 'pricing.agent.publish.modal.accepts.singular'
            : 'pricing.agent.publish.modal.accepts.plural',
          { count: acceptedCount },
        )}
      </Typography>
    ) : null;

  const overridden =
    overriddenCount > 0 ? (
      <Typography color={theme.sk.color.text.blue} variant="paragraph-md-600">
        {i18n.t(
          overriddenCount === 1
            ? 'pricing.agent.publish.modal.overrides.singular'
            : 'pricing.agent.publish.modal.overrides.plural',
          { count: overriddenCount },
        )}
      </Typography>
    ) : null;

  const rejected =
    rejectedCount > 0 ? (
      <Typography color={theme.sk.color.text.error} variant="paragraph-md-600">
        {i18n.t(
          rejectedCount === 1
            ? 'pricing.agent.publish.modal.rejects.singular'
            : 'pricing.agent.publish.modal.rejects.plural',
          { count: rejectedCount },
        )}
      </Typography>
    ) : null;

  const firstSentence =
    accepted || overridden ? (
      <>
        {i18n.t('pricing.agent.publish.modal.overwrite_body.prefix')}
        {accepted}
        {accepted && overridden
          ? i18n.t('pricing.agent.publish.modal.and_connector')
          : null}
        {overridden}
        {i18n.t('pricing.agent.publish.modal.overwrite_body.suffix')}
      </>
    ) : null;

  const secondSentence = rejected ? (
    <>
      {firstSentence ? ' ' : null}
      {rejected}
      {i18n.t('pricing.agent.publish.modal.reject_body.suffix')}
    </>
  ) : null;

  return (
    <View style={styles.base}>
      <Typography variant="paragraph-md">
        {firstSentence}
        {secondSentence}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    marginTop: theme.sk.spacing.spaceSmall,
    maxWidth: 480,
  },
}));
